import React from 'react';
import styled from 'styled-components/macro';
import { responsiveStyle } from 'styled-system';

import Flex from 'modsy-ui-kit/build/Flex';
import Box from 'modsy-ui-kit/build/Box';

/**
 * Higher order component that wraps children with an
 * optional retail partner banner image.
 *
 * if ppo option is passed, banner will be fixed to the top
 */

// ${p => p.ppo && 'width: 100%; position: fixed; top: 0; z-index: 9999'};
const Container = styled(Flex)`
  background: #fff;
  position: fixed;
  top: 0;
  z-index: 3;
`;

export const Banner = styled(Box)`
  background-color: #494949;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 30px;
  margin: 12px 0;
  width: 100%;
  ${responsiveStyle({
    prop: 'bgImage',
    cssProperty: 'background-image'
  })}
`;

export default ({ partner, partnerLogo, children, ppo }) => {
  if (!partnerLogo) {
    return children;
  }

  return (
    <Container column width={1}>
      <Flex ppo={ppo} style={{ backgroundColor: '#494949' }}>
        <Banner width={1} bgImage={[`url(${partnerLogo})`]} />
      </Flex>
      {children}
    </Container>
  );
};
